import { Modal } from "antd";
import React from "react";
import {
  EmailIcon,
  TwitterIcon,
  FacebookIcon,
  WhatsappIcon,
  TelegramIcon,
  EmailShareButton,
  TwitterShareButton,
  FacebookShareButton,
  WhatsappShareButton,
  TelegramShareButton,
} from "react-share";
import { Note } from "../../../../helbest";
import styles from "./ShareModal.module.css";
import { useTranslation } from "react-i18next";

const icons_list = [
  { key: "email", main_icon: EmailShareButton, child_icon: EmailIcon },
  { key: "whatsapp", main_icon: WhatsappShareButton, child_icon: WhatsappIcon },
  { key: "telegram", main_icon: TelegramShareButton, child_icon: TelegramIcon },
  { key: "twitter", main_icon: TwitterShareButton, child_icon: TwitterIcon },
  { key: "facebook", main_icon: FacebookShareButton, child_icon: FacebookIcon },
];

const ShareModal = (props) => {
  const { t } = useTranslation();

  const copy = (e) => {
    e.stopPropagation();
    let i = e.target;
    i.select();
    i.setSelectionRange(0, 99999);
    document.execCommand("copy");
    Note.info("product link copied.", "bottom-center");
  };

  return (
    <Modal
      width="100%"
      open={props.shareModal}
      footer={null}
      className="increase-credit-modal"
      maskClosable={true}
      closable={true}
      onCancel={(e) => {
        e.stopPropagation();
        props.setShareModal(false);
      }}
      styles={{
        body: { paddingTop: "30px" },
      }}
    >
      <div onClick={(e) => e.stopPropagation()}>
        <p className="font-12 text-center my-1">{t("common.share_text")}</p>

        <input
          onClick={(e) => copy(e)}
          className="share-input font-12"
          type="text"
          value={props.value}
          readOnly
        />

        <div className={styles.Icons_container}>
          {icons_list.map((icons_item) => {
            return (
              <icons_item.main_icon
                className="size-8"
                key={icons_item.key}
                children={<icons_item.child_icon size={32} round={true} />}
                url={props.value}
              />
            );
          })}
        </div>
      </div>
    </Modal>
  );
};

export default ShareModal;
